import { Navigate } from "react-router-dom";

export function Dashboard() {
  return <Navigate to="/projects" replace />;
}
